import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, unref as _unref, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "signInPage"
};
const _hoisted_2 = { class: "signInHeading" };
const _hoisted_3 = { class: "pinRow" };
const _hoisted_4 = { class: "pinField" };
const _hoisted_5 = ["value", "onInput", "onKeydown"];
const _hoisted_6 = {
    key: 0,
    class: "pinBanner"
};
const _hoisted_7 = {
    key: 1,
    class: "pinBanner mismatch"
};
const _hoisted_8 = {
    key: 1,
    class: "pinDone"
};
import { ref, computed, getCurrentInstance, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
import { setCreds } from '../utils/native';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SignInPinPage',
    setup(__props) {
        const router = useRouter();
        const instance = getCurrentInstance();
        const cookies = instance?.appContext.config.globalProperties.$cookies;
        const step = ref('set');
        const pin = ref('');
        // Four plain inputs rather than v-otp-input: we render the dots ourselves, so masking is
        // instant. iOS briefly reveals the last character of anything the browser masks (password
        // inputs and -webkit-text-security alike) and that isn't configurable. Owning the focus
        // calls also means focus({ preventScroll: true }) below, instead of patching Vuetify's.
        const digits = ref(['', '', '', '']);
        const reveal = ref(false);
        const validationText = ref(null);
        const entered = computed(() => digits.value.join(''));
        const matches = computed(() => entered.value.length === 4 && entered.value === pin.value);
        const boxes = ref([]);
        function setBox(el, i) {
            if (el)
                boxes.value[i] = el;
        }
        // preventScroll is the whole point: without it iOS scrolls each newly focused box into
        // view, which drags the short page off-screen (see commit caf7e0ab4 for the same fix).
        function focusBox(i) {
            boxes.value[i]?.focus({ preventScroll: true });
        }
        function onInput(i, e) {
            const el = e.target;
            // The box already holds a bullet when masked, so take the last digit typed
            const digit = el.value.replace(/[^0-9]/g, '').slice(-1);
            digits.value[i] = digit;
            // The bound value may be unchanged (bullet to bullet), so Vue won't repaint it for us
            el.value = digit ? (reveal.value ? digit : '\u2022') : '';
            validationText.value = null;
            if (digit && i < 3)
                focusBox(i + 1);
            if (step.value === 'set' && entered.value.length === 4)
                submit();
        }
        function onKeydown(i, e) {
            if (e.key !== 'Backspace')
                return;
            // Step back out of an already-empty box, clearing as we go
            if (!digits.value[i] && i > 0) {
                e.preventDefault();
                digits.value[i - 1] = '';
                focusBox(i - 1);
            }
        }
        function clearDigits() {
            digits.value = ['', '', '', ''];
            focusBox(0);
        }
        // Reached only from SignInPage.signIn(), which sets these. A reload, deep link or expired
        // cookie means there are no credentials to store, so send them back to sign in.
        onMounted(() => {
            if (!cookies?.get('user') || !cookies?.get('pass'))
                router.replace({ path: '/signin' });
        });
        function backToSet() {
            validationText.value = null;
            clearDigits();
            step.value = 'set';
        }
        function submit() {
            validationText.value = null;
            if (!/^\d{4}$/.test(entered.value)) {
                validationText.value = 'PIN must be a 4 digit number';
                return;
            }
            if (step.value === 'set') {
                pin.value = entered.value;
                clearDigits();
                step.value = 'confirm';
                return;
            }
            if (!matches.value) {
                validationText.value = "PINs do not match.";
                clearDigits();
                return;
            }
            // Hand the PIN and credentials to the native host, as ChannelsPage does. Without the
            // credentials the host would store a blank pair for biometric login, so bail instead.
            const user = cookies?.get('user');
            const pass = cookies?.get('pass');
            if (!user || !pass) {
                router.replace({ path: '/signin' });
                return;
            }
            setCreds(pin.value, user, pass);
            step.value = 'done';
        }
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: step.value === 'done' ? '' : 'Security',
                    border: 0,
                    backButton: step.value === 'confirm',
                    onBack: backToSet
                }, null, 8, ["title", "backButton"]),
                (step.value !== 'done')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("h1", null, _toDisplayString(step.value === 'set' ? 'Set your PIN' : 'Confirm your PIN'), 1),
                            _createElementVNode("p", null, _toDisplayString(step.value === 'set'
                                ? 'Choose a memorable 4 digit PIN to sign in super quick next time.'
                                : 'Enter your 4-digit PIN again to make sure it matches.'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "pinToggle spacer" }, null, -1)),
                            _createElementVNode("div", _hoisted_4, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(digits.value, (digit, i) => {
                                    return (_openBlock(), _createElementBlock("input", {
                                        key: i,
                                        ref_for: true,
                                        ref: (el) => setBox(el, i),
                                        class: "pinBox",
                                        value: reveal.value ? digit : (digit ? '\u2022' : ''),
                                        type: "text",
                                        inputmode: "numeric",
                                        autocomplete: "one-time-code",
                                        "aria-label": "PIN digit",
                                        onInput: ($event) => (onInput(i, $event)),
                                        onKeydown: ($event) => (onKeydown(i, $event))
                                    }, null, 40, _hoisted_5));
                                }), 128))
                            ]),
                            _createElementVNode("div", {
                                class: "pinToggle",
                                onClick: _cache[0] || (_cache[0] = ($event) => (reveal.value = !reveal.value))
                            }, [
                                _createVNode(_component_v_icon, {
                                    icon: reveal.value ? 'mdi-eye' : 'mdi-eye-off',
                                    "aria-label": reveal.value ? 'Hide PIN' : 'Show PIN'
                                }, null, 8, ["icon", "aria-label"])
                            ])
                        ]),
                        (step.value === 'confirm' && matches.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[3] || (_cache[3] = [
                                _createElementVNode("div", { class: "pinBannerIcon" }, [
                                    _createElementVNode("svg", {
                                        width: "14",
                                        height: "14",
                                        viewBox: "0 0 16 13.8819",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg"
                                    }, [
                                        _createElementVNode("path", {
                                            d: "M1.00002 7.50812L5.16218 12.3514L15 1.00002",
                                            stroke: "white",
                                            "stroke-width": "2",
                                            "stroke-linecap": "round"
                                        })
                                    ])
                                ], -1),
                                _createElementVNode("span", null, "PINs match", -1)
                            ])))
                            : (validationText.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "pinBannerIcon" }, [
                                        _createElementVNode("svg", {
                                            width: "12",
                                            height: "12",
                                            viewBox: "0 0 12 12",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg"
                                        }, [
                                            _createElementVNode("path", {
                                                d: "M1 1L11 11M11 1L1 11",
                                                stroke: "white",
                                                "stroke-width": "2",
                                                "stroke-linecap": "round"
                                            })
                                        ])
                                    ], -1)),
                                    _createElementVNode("span", null, _toDisplayString(validationText.value), 1)
                                ]))
                                : _createCommentVNode("", true),
                        _createVNode(MGButton, {
                            text: step.value === 'set' ? 'Confirm' : 'Confirm PIN',
                            arrow: true,
                            fullWidth: true,
                            disabled: entered.value.length < 4,
                            onClick: submit
                        }, null, 8, ["text", "disabled"])
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _cache[5] || (_cache[5] = _createStaticVNode("<svg class=\"pinDoneGraphic\" viewBox=\"-8 -8 192 192\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\" data-v-1cf49f48><circle class=\"sonarWave\" cx=\"88\" cy=\"88\" r=\"40\" fill=\"var(--bright-blue-1)\" data-v-1cf49f48></circle><circle class=\"sonarWave w2\" cx=\"88\" cy=\"88\" r=\"40\" fill=\"var(--bright-blue-1)\" data-v-1cf49f48></circle><circle class=\"sonarWave w3\" cx=\"88\" cy=\"88\" r=\"40\" fill=\"var(--bright-blue-1)\" data-v-1cf49f48></circle><circle cx=\"88\" cy=\"88\" r=\"40\" fill=\"var(--bright-blue-1)\" data-v-1cf49f48></circle><path d=\"M87.4961 64C94.4428 64.0001 99.8272 70.0179 99.8272 77.124V79.4238H101.303C101.829 79.4238 102.345 79.4216 102.778 79.457C103.235 79.4944 103.776 79.5828 104.318 79.8594C104.977 80.195 105.528 80.7054 105.912 81.332L106.066 81.6074L106.161 81.8105C106.364 82.2836 106.436 82.7465 106.469 83.1465C106.504 83.5802 106.502 84.0961 106.502 84.623V102.8C106.502 103.327 106.504 103.843 106.469 104.276C106.431 104.734 106.343 105.274 106.066 105.816C105.683 106.569 105.071 107.181 104.318 107.564C103.776 107.841 103.235 107.928 102.778 107.966C102.345 108.001 101.829 108 101.303 108H73.7002C73.1732 108 72.6574 108.001 72.2236 107.966C71.7665 107.928 71.2264 107.841 70.6836 107.564C69.9311 107.181 69.319 106.569 68.9356 105.816C68.659 105.274 68.5715 104.734 68.5342 104.276C68.4987 103.843 68.5 103.327 68.5 102.8V84.623C68.5 84.0961 68.4987 83.5802 68.5342 83.1465C68.5716 82.6894 68.6591 82.15 68.9356 81.6074C69.319 80.8549 69.9311 80.2429 70.6836 79.8594C71.2264 79.5828 71.7665 79.4944 72.2236 79.457C72.6574 79.4216 73.1732 79.4238 73.7002 79.4238H75.166V77.124C75.166 70.0179 80.5495 64.0001 87.4961 64ZM73.7002 83.4238C73.1073 83.4238 72.782 83.4253 72.5488 83.4443C72.5399 83.4451 72.5314 83.4465 72.5234 83.4473C72.5227 83.4553 72.5212 83.4637 72.5205 83.4727C72.5015 83.7058 72.5 84.0302 72.5 84.623V102.8C72.5 103.393 72.5015 103.718 72.5205 103.951C72.5212 103.96 72.5227 103.968 72.5234 103.976C72.5315 103.976 72.5399 103.979 72.5488 103.979C72.782 103.999 73.1073 104 73.7002 104H101.303C101.895 104 102.22 103.999 102.453 103.979C102.462 103.979 102.47 103.976 102.478 103.976C102.478 103.968 102.481 103.96 102.481 103.951C102.501 103.718 102.502 103.393 102.502 102.8V84.623C102.502 84.0302 102.5 83.7058 102.481 83.4727C102.481 83.4637 102.478 83.4553 102.478 83.4473C102.47 83.4466 102.462 83.445 102.453 83.4443C102.22 83.4253 101.895 83.4238 101.303 83.4238H73.7002ZM88.3516 89.585C89.4559 89.5852 90.3516 90.4806 90.3516 91.585C90.3515 92.2631 90.0124 92.861 89.4961 93.2227V96.0342C89.4961 97.1387 88.6006 98.0341 87.4961 98.0342C86.3916 98.034 85.4961 97.1387 85.4961 96.0342V93.2148C84.9856 92.8525 84.6514 92.2586 84.6514 91.585C84.6514 90.4804 85.5468 89.585 86.6514 89.585H88.3516ZM87.4961 68C83.0321 68.0002 79.166 71.9433 79.166 77.124V79.4238H95.8272V77.124C95.8272 71.9432 91.9601 68.0001 87.4961 68Z\" fill=\"var(--background-color)\" data-v-1cf49f48></path></svg><div class=\"pinDoneCopy\" data-v-1cf49f48><h1 data-v-1cf49f48>Your PIN is set</h1><p data-v-1cf49f48>You can use it to securely access your Money Guided account.</p></div>", 2)),
                        _createVNode(MGButton, {
                            class: "ctaButton",
                            text: "Continue",
                            arrow: true,
                            fullWidth: true,
                            onClick: _cache[1] || (_cache[1] = ($event) => (_unref(router).push({ path: '/signin/details' })))
                        })
                    ]))
            ], 64));
        };
    }
});
